namespace Pages {
    export class UsersPage {
        private readonly _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }
        async index() {
            return new PageViewResult("Users/", {});
        }
        async add() {
            return new PageViewResult("Users/add/", new Entities.User({
                username: "",
                firstName: "",
                lastName: "",
                password: ""
            }));
        }
        async insert({ model }: { model: Entities.User }) {

            model.setPassword(model.password);
            await this._repository.saveDocument(model);

            return new PageActionResult(
                new PageActionBack(new PageActionEvent("userChanged"))
            );
        }
        async edit({ id }: { id: string }) {
            const {document: user} = await this._repository.getDocument<Entities.User>(id);
            user.password = "";

            return new PageViewResult("Users/edit/", 
                user
            );
        }

        async update({ id, model }: { id: string, model: Entities.User}) {
            
            if (model.password == "") {
                const {document: user} = await this._repository.getDocument<Entities.User>(id);
                model.password = user.password;
            } else {
                model.setPassword(model.password);
            }
            await this._repository.saveDocument(model);

            return new PageActionResult(
                new PageActionBack(new PageActionEvent("userChanged"))
            );
        }

        async delete({ id, model }: {id: string, model: Entities.User}) {
            await this._repository.deleteDocument(model.id);
            return new PageActionResult(
                new PageActionBack(new PageActionEvent("userChanged"))
            );
        }

    }
}